import React from "react";
import { DataPropsType } from "../../../constants/types";

export const DataPropsContext = React.createContext<DataPropsType | null>(null);
